import { Box, Heading, Text } from "@chakra-ui/react";
import Layout from "../components/Layout";
import LastVideos from "../components/LastVideos";
import OtherVideos from "../components/OtherVideos";

const AcaolFlix = () => {
  return (
    <Layout>
      <Box>
        <LastVideos />
        <Box
          py={[6, 10]}
          px={[4, 6, 8]}
          maxW="1400px"
          mx="auto"
        >
          <Heading
            fontSize={["1.6rem", "2rem"]}
            color="green.700"
            mb={1}
            borderLeft="4px solid"
            borderColor="green.400"
            pl={4}
          >
            Todos os Vídeos
          </Heading>
          <Text color="gray.500" pl={4} mb={8} fontSize="1rem">
            Pesquise e explore todo o acervo da Jornada Maçônica
          </Text>
          <OtherVideos />
        </Box>
      </Box>
    </Layout>
  );
};
export default AcaolFlix;
